import { httpsCallable } from "firebase/functions";
import type { PriceLookup } from "@shared/types";
import { functions } from "../firebase";

export interface LookupProductPriceCallInput {
  projectId: string;
  url: string;
  itemName?: string;
}

export interface LookupProductPriceCallResult {
  price: number | null;
  currency: string;
  productName: string;
  shipping: number | null;
  source: PriceLookup["source"];
  confidence: PriceLookup["confidence"];
  note: string;
  flowVersion: string;
}

export async function callLookupProductPrice(
  input: LookupProductPriceCallInput
): Promise<LookupProductPriceCallResult> {
  const call = httpsCallable<LookupProductPriceCallInput, LookupProductPriceCallResult>(
    functions,
    "lookupProductPrice",
    { timeout: 70_000 }
  );
  const result = await call(input);
  return result.data;
}
